import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchMentorDetails } from "@/services/mentorDetailService";

export const useMentorProfile = (mentorId: string | undefined) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ["mentor-details", mentorId],
    queryFn: async () => {
      console.log('🔄 [useMentorProfile] Buscando dados do mentor:', mentorId);
      const data = await fetchMentorDetails(mentorId || "");
      console.log('✅ [useMentorProfile] Dados recebidos:', data);
      console.log('🔗 [useMentorProfile] Links sociais:', data.social);
      return data;
    },
    enabled: !!mentorId,
    refetchOnWindowFocus: false, // Não refetch ao focar a janela
    refetchOnReconnect: true, // Garante que os dados sejam atualizados ao reconectar
    staleTime: 5 * 60 * 1000 // Considera dados "frescos" por 5 minutos
  });
};
